export function init() {
	const group = document.querySelector(".wp-block-group.is-style-summary");

	if (!group) {
		return;
	}

	const newGroup = document.createElement("div");
	newGroup.classList.add("is-style-summary__container");

	// Move all children into the new container
	while (group.firstChild) {
		newGroup.appendChild(group.firstChild);
	}

	group.appendChild(newGroup);

	const updateButtonVisibility = () => {

		// Check if content exceeds the height of the container
		if (newGroup.scrollHeight > newGroup.clientHeight) {
			if (!group.querySelector(".is-style-summary__toggle")) {

				// Create the toggle button if it doesn't already exist
				const toggleButton = document.createElement("button");
				toggleButton.classList.add("is-style-summary__toggle");
				toggleButton.innerHTML = "Vis mer";

				toggleButton.addEventListener("click", () => {
					newGroup.classList.toggle("open");
					toggleButton.classList.toggle("open");

					// Update button text based on state
					toggleButton.innerHTML = newGroup.classList.contains("open")
						? "Vis mindre"
						: "Vis mer";

					// Adjust height dynamically when toggling
					newGroup.style.height = newGroup.classList.contains("open")
						? `${newGroup.scrollHeight}px`
						: "250px";
				});

				group.appendChild(toggleButton);
			}
		} else {
			// Remove the button if the content fits
			const existingToggleButton = group.querySelector(".is-style-summary__toggle");
			if (existingToggleButton) {
				existingToggleButton.remove();
			}
			newGroup.style.height = ""; // Reset height if no overflow
		}
	};

	updateButtonVisibility();

	window.addEventListener("resize", updateButtonVisibility);
}
